import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'

export const showScoutBannerSelector = createSelector(
  pageSelectors.scoutBanner,
  (scout?: WpsRuntime.atv.wps.ScoutBannerModelProps) =>
    Boolean(!global.__NATIVEAPP__ && scout)
)

